import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'


export const shopSchema = new schema.Entity(
    'shop',
    {},
    {
        idAttribute: 'idname',
    }
)
export const productCatalogSchema = new schema.Entity(
    'product_catalog',
    {},
    {
        idAttribute: 'idname',
    }
)
export const productSchema = new schema.Entity(
    'products',
    {},
    {
        idAttribute: 'idname',
    }
)
export const productVariantSchema = new schema.Entity(
    'product_variants',
    {},
    {
        idAttribute: 'id',
    }
)

/**

 * @type {{schema: schema.Entity<any>, path: string, transform: (function(...[*]=)), method: string, paramsFields: [string, string, string], root: string, name: string, backend: string}}
 */


export const shop_createNew_Api = {
    name: 'shop_createNew_Api',
    backend: `Route::post('shops/{type}/{id}/create-new', 'ShopController@createNew');`,
    root: API_ROOT_URL,
    path: '/shops/:type/:id/create-new',
    method: 'POST',
    schema: shopSchema,
    transform: createTransform(shopSchema, 'data'),
}

export const shop_delete_Api = {
    name: 'shop_delete_Api',
    backend: `Route::post('shops/shop/{id}/delete', 'ShopController@delete');`,
    root: API_ROOT_URL,
    path: '/shops/shop/:id/delete',
    method: 'POST',
    schema: shopSchema,
    transform: createTransform(shopSchema, 'data'),
}

export const shop_update_Api = {
    name: 'shop_update_Api',
    backend: `Route::post('shops/shop/{id}/edit', 'ShopController@update');`,
    root: API_ROOT_URL,
    path: '/shops/shop/:id/edit',
    method: 'POST',
    schema: shopSchema,
    transform: createTransform(shopSchema, 'data'),
}

export const shop_getById_Api = {
    backend: `Route::get('shops/shop/{id}/get', 'ShopController@getById');`,
    root: API_ROOT_URL,
    path: '/shops/shop/:id/get',
    method: 'GET',
    schema: shopSchema,
    transform: createTransform(shopSchema, 'data'),
}

export const shop_fetchItems_Api = {
    backend: `Route::get('shops/{type}/{id}/fetch-items', 'ShopController@fetchItems');`,
    root: API_ROOT_URL,
    path: '/shops/:type/:id/fetch-items',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'status'],
    schema: shopSchema,
    transform: createListTransform(shopSchema),
}


/*
PRODUCT_CATALOGS
 */
export const shop_createNewCatalog_Api = {
    name: 'shop_createNew_Api',
    backend: `Route::post('product-catalogs/{type}/{id}/create-new', 'ShopController@createNewCatalog');`,
    root: API_ROOT_URL,
    path: '/product-catalogs/:type/:id/create-new',
    method: 'POST',
    schema: shopSchema,
    transform: createTransform(shopSchema, 'data'),
}

export const shop_deleteCatalog_Api = {
    name: 'shop_deleteCatalog_Api',
    backend: `Route::post('product-catalogs/catalog/{id}/delete', 'ShopController@deleteCatalog');`,
    root: API_ROOT_URL,
    path: '/product-catalogs/catalog/:id/delete',
    method: 'POST',
    schema: shopSchema,
    transform: createTransform(shopSchema, 'data'),
}

export const shop_updateCatalog_Api = {
    name: 'shop_updateCatalog_Api',
    backend: `Route::post('product-catalogs/catalog/{id}/edit', 'ShopController@updateCatalog');`,
    root: API_ROOT_URL,
    path: '/product-catalogs/catalog/:id/edit',
    method: 'POST',
    schema: shopSchema,
    transform: createTransform(shopSchema, 'data'),
}


export const shop_getCatalogById_Api = {
    backend: `Route::get('product-catalogs/catalog/{id}/get', 'ShopController@getCatalogById');`,
    root: API_ROOT_URL,
    path: '/product-catalogs/catalog/:id/get',
    method: 'GET',
    schema: productCatalogSchema,
    transform: createTransform(productCatalogSchema, 'data'),
}

export const shop_fetchCatalogItems_Api = {
    backend: `Route::get('product-catalogs/{type}/{id}/fetch-items', 'ShopController@fetchCatalogItems');`,
    root: API_ROOT_URL,
    path: '/product-catalogs/:type/:id/fetch-items',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'status'],
    schema: productCatalogSchema,
    transform: createListTransform(productCatalogSchema),
}

/*
PRODUCTS
 */


export const shop_getDiscountProducts_Api = {
    backend: `Route::get('products/get-random-discount-products', 'ProductController@getDiscountProducts');`,
    root: API_ROOT_URL,
    path: '/products/get-random-discount-products',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'container_type', 'container_id'],
    schema: productSchema,
    transform: createListTransform(productSchema),
}

export const shop_getProducts_Api = {
    backend: `Route::get('products/shop/{id}/get-products', 'ProductController@getShopProducts');`,
    root: API_ROOT_URL,
    path: '/products/shop/:id/get-products',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'status', 'is_upcoming', 'is_discount', 'is_newest', 'product_type', 'product_catalog_id'],
    schema: productSchema,
    transform: createListTransform(productSchema),
}

export const product_getProducts_Api = {
    backend: `Route::get('products/get-products', 'ProductController@getProducts');`,
    root: API_ROOT_URL,
    path: '/products/get-products',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'status', 'is_upcoming', 'is_discount', 'is_newest', 'product_type', 'product_catalog_id'],
    schema: productSchema,
    transform: createListTransform(productSchema),
}

export const shop_getNewestProducts_Api = {
    backend: `Route::get('products/shop/{id}/get-newest-products', 'ProductController@getNewestShopProducts');`,
    root: API_ROOT_URL,
    path: '/products/shop/:id/get-newest-products',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'status'],
    schema: productSchema,
    transform: createListTransform(productSchema),
}


export const shop_fetchHighlightedStoreItems_Api = {
    backend: `Route::get('shops/get-highlighted-stores', 'ShopController@fetchHighlightedStoreItems');`,
    root: API_ROOT_URL,
    path: '/shops/get-highlighted-stores',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'status'],
    schema: shopSchema,
    transform: createListTransform(shopSchema),
}


export const product_createNew_Api = {
    name: 'product_createNew_Api',
    backend: `Route::post('products/shop/{id}/create-new', 'ProductController@createNew');`,
    root: API_ROOT_URL,
    path: '/products/shop/:id/create-new',
    method: 'POST',
    schema: productSchema,
    transform: createTransform(productSchema, 'data'),
}

export const product_update_Api = {
    name: 'product_update_Api',
    backend: `Route::post('products/product/{id}/edit', 'ProductController@update');`,
    root: API_ROOT_URL,
    path: '/products/product/:id/edit',
    method: 'POST',
    schema: productSchema,
    transform: createTransform(productSchema, 'data'),
}

export const product_delete_Api = {
    name: 'product_delete_Api',
    backend: `Route::post('products/product/{id}/delete', 'ProductController@delete');`,
    root: API_ROOT_URL,
    path: '/products/product/:id/delete',
    method: 'POST',
    schema: productSchema,
    transform: createTransform(productSchema, 'data'),
}

export const product_getById_Api = {
    backend: `Route::get('products/product/{id}/get', 'ProductController@getById');`,
    root: API_ROOT_URL,
    path: '/products/product/:id/get',
    method: 'GET',
    schema: productSchema,
    transform: createTransform(productSchema, 'data'),
}

export const product_publish_Api = {
    name: 'product_publish_Api',
    backend: `Route::post('products/product/{id}/publish', 'ProductController@publish');`,
    root: API_ROOT_URL,
    path: '/products/product/:id/publish',
    method: 'POST',
    schema: productSchema,
    transform: createTransform(productSchema, 'data'),
}

export const product_addVariant_Api = {
    name: 'product_addVariant_Api',
    backend: `Route::post('products/product/{id}/variant/create-new', 'ProductController@addVariant');`,
    root: API_ROOT_URL,
    path: '/products/product/:id/variant/create-new',
    method: 'POST',
    schema: productVariantSchema,
    transform: createTransform(productVariantSchema, 'data'),
}

export const product_editVariant_Api = {
    name: 'product_editVariant_Api',
    backend: `Route::post('products/variant/{id}/edit', 'ProductController@editVariant');`,
    root: API_ROOT_URL,
    path: '/products/variant/:id/edit',
    method: 'POST',
    schema: productVariantSchema,
    transform: createTransform(productVariantSchema, 'data'),
}

export const product_deleteVariant_Api = {
    name: 'product_deleteVariant_Api',
    backend: `Route::post('products/variant/{id}/delete', 'ProductController@deleteVariant');`,
    root: API_ROOT_URL,
    path: '/products/variant/:id/delete',
    method: 'POST',
    schema: productVariantSchema,
    transform: createTransform(productVariantSchema, 'data'),
}

export const shop_getProductCatalogs_Api = {
    backend: `Route::get('products/shop/{id}/get-product-catalogs', 'ProductController@getProductCatalogs');`,
    root: API_ROOT_URL,
    path: '/products/shop/:id/get-product-catalogs',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'status'],
    schema: productCatalogSchema,
    transform: createListTransform(productCatalogSchema),
}

export const productUnitSchema = new schema.Entity(
    'product_units',
    {},
    {
        idAttribute: 'id',
    }
)
export const shop_getProductUnits_Api = {
    backend: `Route::get('products/get-product-units', 'ProductController@getProductUnits');`,
    root: API_ROOT_URL,
    path: '/products/get-product-units',
    method: 'GET',
    paramsFields: ['keyword', 'sort_by', 'status'],
    schema: productUnitSchema,
    transform: createListTransform(productUnitSchema),
}

